"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && (typeof from === "undefined" ? "undefined" : _type_of(from)) === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// legacy.ts
var legacy_exports = {};
__export(legacy_exports, {
    AnalyticsProvider: function() {
        return AnalyticsProvider;
    },
    Button: function() {
        return Button;
    },
    DialogTracker: function() {
        return DialogTracker;
    },
    Element: function() {
        return Element;
    },
    Page: function() {
        return Page;
    },
    configure: function() {
        return configure;
    },
    createDialogTracker: function() {
        return createDialogTracker;
    },
    flush: function() {
        return flush;
    },
    withTrackingLegacy: function() {
        return withTrackingLegacy;
    }
});
module.exports = __toCommonJS(legacy_exports);
// providerLegacy.tsx
var import_react = require("react");
// utils.ts
function normalizeEventName(eventName) {
    return eventName.replace(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/gi, "{id}");
}
// track.ts
var Tracker = /*#__PURE__*/ function() {
    function _Tracker() {
        _class_call_check(this, _Tracker);
        this.config = {};
        this.isConfigured = false;
        this.eventQueue = [];
        this._queueTimer = null;
        this.currentPage = "";
        this.referPage = "";
        // Deduplication: track last page view to prevent duplicates
        this.lastPageView = null;
        // Circuit breaker state
        this.circuitState = "closed";
        this.consecutiveFailures = 0;
        this.lastFailureTime = 0;
        this.failureThreshold = 5;
        // Open circuit after 5 consecutive failures
        this.resetTimeoutMs = 6e4;
        this.sessionId = this.getStoredSessionId();
        if (typeof window !== "undefined") {
            this.initAutoTracking();
        }
    }
    _create_class(_Tracker, [
        {
            // 配置全局參數
            key: "configure",
            value: function configure(config) {
                this.config = _object_spread({}, this.config, config);
                if (config.trackingApiUrl) {
                    var _this_sessionId;
                    this.isConfigured = true;
                    if ((_this_sessionId = this.sessionId) === null || _this_sessionId === void 0 ? void 0 : _this_sessionId.startsWith("session_")) {
                        console.log("[Analytics] Clearing client-generated sessionId for external API mode");
                        this.sessionId = void 0;
                        if (typeof window !== "undefined") {
                            sessionStorage.removeItem("tracker_session_id");
                        }
                    }
                }
            }
        },
        {
            // Get stored session ID (from previous API response or client-generated)
            key: "getStoredSessionId",
            value: function getStoredSessionId() {
                if (typeof window === "undefined") return void 0;
                return sessionStorage.getItem("tracker_session_id") || void 0;
            }
        },
        {
            // Generate client-side session ID (for legacy/local API only)
            key: "generateClientSessionId",
            value: function generateClientSessionId() {
                var sessionId = "session_".concat(Date.now(), "_").concat(Math.random().toString(36).slice(2, 11));
                sessionStorage.setItem("tracker_session_id", sessionId);
                return sessionId;
            }
        },
        {
            // Save session ID from API response
            key: "saveSessionId",
            value: function saveSessionId(sessionId) {
                this.sessionId = sessionId;
                if (typeof window !== "undefined") {
                    sessionStorage.setItem("tracker_session_id", sessionId);
                }
            }
        },
        {
            // 初始化自動追蹤
            key: "initAutoTracking",
            value: function initAutoTracking() {
                var _this = this;
                if (typeof window === "undefined") return;
                this.trackPageChange();
                window.addEventListener("beforeunload", function() {
                    _this.flush();
                });
                document.addEventListener("visibilitychange", function() {
                    if (document.hidden) {
                        _this.flush();
                    }
                });
            }
        },
        {
            // 追蹤頁面變化
            key: "trackPageChange",
            value: function trackPageChange() {
                var _this = this;
                if (typeof window === "undefined") return;
                var updatePage = function() {
                    var newPage = window.location.pathname;
                    if (newPage !== _this.currentPage) {
                        _this.referPage = _this.currentPage;
                        _this.currentPage = newPage;
                        console.log("[Analytics] Page changed from", _this.referPage, "to", _this.currentPage);
                    }
                };
                this.currentPage = window.location.pathname;
                var originalPushState = history.pushState;
                var originalReplaceState = history.replaceState;
                history.pushState = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    originalPushState.apply(this, args);
                    updatePage();
                    window.dispatchEvent(new Event("pushstate"));
                };
                history.replaceState = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    originalReplaceState.apply(this, args);
                    updatePage();
                    window.dispatchEvent(new Event("replacestate"));
                };
                window.addEventListener("popstate", updatePage);
                window.addEventListener("pushstate", updatePage);
                window.addEventListener("replacestate", updatePage);
            }
        },
        {
            // 啟動隊列定時器（每 15 秒發送一次）
            key: "startQueueTimer",
            value: function startQueueTimer() {
                var _this = this;
                if (typeof window === "undefined") return;
                if (this._queueTimer) return;
                this._queueTimer = setInterval(function() {
                    if (_this.eventQueue.length > 0) {
                        _this.flush();
                    }
                }, 15e3);
            }
        },
        {
            // 停止隊列定時器
            key: "stopQueueTimer",
            value: function stopQueueTimer() {
                if (this._queueTimer) {
                    clearInterval(this._queueTimer);
                    this._queueTimer = null;
                }
            }
        },
        {
            // 收集設備資訊
            key: "getDeviceInfo",
            value: function getDeviceInfo() {
                if (typeof window === "undefined") return {};
                var ua = navigator.userAgent;
                var isMobile = /Mobile|Android|iPhone/i.test(ua);
                var isTablet = /iPad|Tablet/i.test(ua);
                var deviceType = isMobile ? "mobile" : isTablet ? "tablet" : "desktop";
                var os = "unknown";
                var osVersion = "";
                var windowsMatch = ua.match(/Windows NT (\d+\.\d+)/);
                var macMatch = ua.match(/Mac OS X (\d+[._]\d+)/);
                var androidMatch = ua.match(/Android (\d+\.\d+)/);
                var iosMatch = ua.match(/iPhone OS (\d+_\d+)/);
                if (windowsMatch) {
                    os = "Windows";
                    osVersion = windowsMatch[1];
                } else if (macMatch) {
                    os = "macOS";
                    osVersion = macMatch[1].replace("_", ".");
                } else if (androidMatch) {
                    os = "Android";
                    osVersion = androidMatch[1];
                } else if (iosMatch) {
                    os = "iOS";
                    osVersion = iosMatch[1].replace("_", ".");
                }
                var browser = "unknown";
                var browserVersion = "";
                var chromeMatch = ua.match(/Chrome\/(\d+)/);
                var firefoxMatch = ua.match(/Firefox\/(\d+)/);
                var safariMatch = ua.match(/Safari\/(\d+)/);
                var edgeMatch = ua.match(/Edg\/(\d+)/);
                if (chromeMatch && !/Edg/.test(ua)) {
                    browser = "Chrome";
                    browserVersion = chromeMatch[1];
                } else if (firefoxMatch) {
                    browser = "Firefox";
                    browserVersion = firefoxMatch[1];
                } else if (safariMatch && !/Chrome/.test(ua)) {
                    browser = "Safari";
                    browserVersion = safariMatch[1];
                } else if (edgeMatch) {
                    browser = "Edge";
                    browserVersion = edgeMatch[1];
                }
                return {
                    deviceType: deviceType,
                    deviceModel: deviceType,
                    os: os,
                    osVersion: osVersion,
                    browser: browser,
                    browserVersion: browserVersion
                };
            }
        },
        {
            // 獲取網路資訊
            key: "getNetworkInfo",
            value: function getNetworkInfo() {
                if (typeof window === "undefined" || typeof navigator === "undefined" || !("connection" in navigator)) {
                    return {};
                }
                var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
                if (!connection) return {};
                return {
                    networkType: connection.type || "unknown",
                    networkEffectiveType: connection.effectiveType || "unknown"
                };
            }
        },
        {
            // 添加事件到隊列
            key: "addToQueue",
            value: function addToQueue(event) {
                this.eventQueue.push(event);
                console.log("[Analytics] Event queued:", event.eventName, "Queue size:", this.eventQueue.length);
                if (!this._queueTimer) {
                    this.startQueueTimer();
                }
            }
        },
        {
            // Check if circuit breaker should allow requests
            key: "shouldAllowRequest",
            value: function shouldAllowRequest() {
                if (this.circuitState === "closed") {
                    return true;
                }
                if (this.circuitState === "open") {
                    var timeSinceLastFailure = Date.now() - this.lastFailureTime;
                    if (timeSinceLastFailure >= this.resetTimeoutMs) {
                        console.log("[Analytics] Circuit breaker: transitioning from OPEN to HALF-OPEN");
                        this.circuitState = "half-open";
                        return true;
                    }
                    return false;
                }
                return true;
            }
        },
        {
            // Record a successful request
            key: "recordSuccess",
            value: function recordSuccess() {
                if (this.circuitState === "half-open") {
                    console.log("[Analytics] Circuit breaker: probe succeeded, closing circuit");
                }
                this.consecutiveFailures = 0;
                this.circuitState = "closed";
            }
        },
        {
            // Record a failed request
            key: "recordFailure",
            value: function recordFailure() {
                this.consecutiveFailures++;
                this.lastFailureTime = Date.now();
                if (this.circuitState === "half-open") {
                    console.log("[Analytics] Circuit breaker: probe failed, re-opening circuit");
                    this.circuitState = "open";
                } else if (this.consecutiveFailures >= this.failureThreshold) {
                    console.log("[Analytics] Circuit breaker: ".concat(this.consecutiveFailures, " consecutive failures, opening circuit for ").concat(this.resetTimeoutMs / 1e3, "s"));
                    this.circuitState = "open";
                }
            }
        },
        {
            key: "flush",
            value: // 發送隊列中的所有事件
            function flush() {
                return _async_to_generator(function() {
                    var timeUntilRetry, events, isExternalApi;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.eventQueue.length === 0) return [
                                    2
                                ];
                                if (!this.isConfigured) {
                                    console.log("[Analytics] Waiting for configuration, events queued:", this.eventQueue.length);
                                    return [
                                        2
                                    ];
                                }
                                if (!this.shouldAllowRequest()) {
                                    timeUntilRetry = Math.ceil((this.resetTimeoutMs - (Date.now() - this.lastFailureTime)) / 1e3);
                                    console.log("[Analytics] Circuit breaker OPEN: skipping flush (".concat(this.eventQueue.length, " events queued, retry in ").concat(timeUntilRetry, "s)"));
                                    return [
                                        2
                                    ];
                                }
                                events = this.eventQueue.map(function(event) {
                                    return _object_spread_props(_object_spread({}, event), {
                                        eventName: normalizeEventName(event.eventName)
                                    });
                                });
                                this.eventQueue = [];
                                this.stopQueueTimer();
                                console.log("[Analytics] Flushing events:", events.length);
                                isExternalApi = !!this.config.trackingApiUrl;
                                if (!isExternalApi && !this.sessionId) {
                                    this.sessionId = this.generateClientSessionId();
                                }
                                if (!isExternalApi) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.sendEventsToExternalApi(events)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                console.log("[Analytics] No external API configured, skipping event send");
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "sendEventsToExternalApi",
            value: // Send all events to external tracking API in a single batch request
            function sendEventsToExternalApi(events) {
                return _async_to_generator(function() {
                    var _this, endpoint, apiEvents, response, _this_eventQueue, errorText, data, e, error, _this_eventQueue1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    9,
                                    ,
                                    10
                                ]);
                                endpoint = this.sessionId ? "".concat(this.config.trackingApiUrl, "/entities/").concat(this.sessionId, "/events") : "".concat(this.config.trackingApiUrl, "/entities/events");
                                apiEvents = events.map(function(event) {
                                    return {
                                        eventType: event.eventType,
                                        eventName: event.eventName,
                                        production: event.production,
                                        platform: event.platform,
                                        pageName: event.pageName || "",
                                        componentName: event.componentName || "",
                                        timestamp: event.timestamp,
                                        refer: event.refer || "",
                                        exposeTime: event.exposeTime || 0,
                                        deviceType: event.deviceType || "",
                                        osVersion: event.os && event.osVersion ? "".concat(event.os, " ").concat(event.osVersion) : event.osVersion || "",
                                        browserVersion: event.browser && event.browserVersion ? "".concat(event.browser, " ").concat(event.browserVersion) : event.browserVersion || "",
                                        networkType: event.networkType || "",
                                        networkEffectiveType: event.networkEffectiveType || "",
                                        pageUrl: event.pageUrl || "",
                                        pageTitle: event.pageTitle || "",
                                        properties: event.properties || "{}",
                                        employeeId: _this.config.employeeId || "",
                                        companyId: _this.config.companyId || "",
                                        companyName: _this.config.companyName || "",
                                        employeeName: _this.config.userName || ""
                                    };
                                });
                                return [
                                    4,
                                    fetch(endpoint, {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        credentials: "include",
                                        body: JSON.stringify(apiEvents)
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                if (!!response.ok) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    response.text()
                                ];
                            case 3:
                                errorText = _state.sent();
                                console.error("[Analytics] Failed to send events:", response.status, response.statusText, errorText);
                                (_this_eventQueue = this.eventQueue).unshift.apply(_this_eventQueue, _to_consumable_array(events));
                                this.startQueueTimer();
                                this.recordFailure();
                                return [
                                    3,
                                    8
                                ];
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 5:
                                data = _state.sent();
                                if (data.sessionId && !this.sessionId) {
                                    console.log("[Analytics] Received sessionId from API:", data.sessionId);
                                    this.saveSessionId(data.sessionId);
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                console.log("[Analytics] Batch of", events.length, "events sent to API successfully");
                                this.recordSuccess();
                                _state.label = 8;
                            case 8:
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                error = _state.sent();
                                console.error("[Analytics] Error sending events to API:", _instanceof(error, Error) ? error.message : String(error), error);
                                (_this_eventQueue1 = this.eventQueue).unshift.apply(_this_eventQueue1, _to_consumable_array(events));
                                this.startQueueTimer();
                                this.recordFailure();
                                return [
                                    3,
                                    10
                                ];
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "sendEventsToLegacyApi",
            value: // Send batch events to legacy local API
            function sendEventsToLegacyApi(events) {
                return _async_to_generator(function() {
                    var endpoint, response, _this_eventQueue, errorText, error, _this_eventQueue1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                endpoint = this.config.apiEndpoint || "/api/track";
                                return [
                                    4,
                                    fetch(endpoint, {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        credentials: "same-origin",
                                        body: JSON.stringify({
                                            events: events,
                                            sessionId: this.sessionId
                                        })
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!!response.ok) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.text()
                                ];
                            case 2:
                                errorText = _state.sent();
                                console.error("[Analytics] Failed to send events:", response.status, response.statusText, errorText);
                                (_this_eventQueue = this.eventQueue).unshift.apply(_this_eventQueue, _to_consumable_array(events));
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                console.log("[Analytics] Events sent to legacy API successfully");
                                _state.label = 4;
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                console.error("[Analytics] Error sending events to legacy API:", _instanceof(error, Error) ? error.message : String(error), error);
                                (_this_eventQueue1 = this.eventQueue).unshift.apply(_this_eventQueue1, _to_consumable_array(events));
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            // 創建追蹤事件
            key: "createEvent",
            value: function createEvent(eventType, eventName, pageName, componentName, properties) {
                var deviceInfo = this.getDeviceInfo();
                var networkInfo = this.getNetworkInfo();
                var referPageName = this.referPage ? this.cleanPageName(this.referPage) : void 0;
                return _object_spread_props(_object_spread({
                    eventType: eventType,
                    eventName: eventName,
                    production: this.config.production,
                    platform: this.config.platform,
                    pageName: pageName,
                    componentName: componentName,
                    timestamp: /* @__PURE__ */ new Date().toISOString(),
                    refer: referPageName,
                    // Now stores the cleaned page name (e.g., "Home", "AdminDashboards")
                    sessionId: this.sessionId
                }, deviceInfo, networkInfo), {
                    pageUrl: typeof window !== "undefined" ? window.location.href : "",
                    pageTitle: typeof document !== "undefined" ? document.title : "",
                    viewportWidth: typeof window !== "undefined" ? window.innerWidth : 0,
                    viewportHeight: typeof window !== "undefined" ? window.innerHeight : 0,
                    properties: properties ? JSON.stringify(properties) : void 0
                });
            }
        },
        {
            key: "cleanPageName",
            value: function cleanPageName(pathname) {
                var parts = pathname.replace(/^\//, "").split("/").filter(Boolean);
                if (parts.length === 0) {
                    return "Home";
                }
                return parts.map(function(part) {
                    return part.charAt(0).toUpperCase() + part.slice(1);
                }).join("");
            }
        },
        {
            // 鏈式 API 建構器
            key: "Page",
            value: function Page(pageName) {
                var _this = this;
                var currentPageName = pageName || (typeof window !== "undefined" ? this.cleanPageName(window.location.pathname) : "");
                return {
                    name: function(name) {
                        return {
                            view: function(properties) {
                                var event = _this.createEvent("view", "View_".concat(name), name, void 0, properties);
                                _this.addToQueue(event);
                            }
                        };
                    },
                    view: function(properties) {
                        var now = Date.now();
                        var path = typeof window !== "undefined" ? window.location.pathname : "";
                        if (_this.lastPageView && _this.lastPageView.path === path && now - _this.lastPageView.timestamp < 100) {
                            console.log("[Analytics] Skipping duplicate page view for:", path);
                            return;
                        }
                        _this.lastPageView = {
                            path: path,
                            timestamp: now
                        };
                        var event = _this.createEvent("view", "View_".concat(currentPageName), currentPageName, void 0, properties);
                        _this.addToQueue(event);
                    }
                };
            }
        },
        {
            key: "Button",
            value: function Button(buttonName) {
                var _this = this;
                return {
                    name: function(name) {
                        return {
                            click: function(properties) {
                                var pageName = typeof window !== "undefined" ? _this.cleanPageName(window.location.pathname) : "";
                                var eventName = "Click_".concat(pageName, "_").concat(name);
                                var event = _this.createEvent("click", eventName, pageName, name, properties);
                                _this.addToQueue(event);
                            }
                        };
                    },
                    click: function(properties) {
                        var pageName = typeof window !== "undefined" ? _this.cleanPageName(window.location.pathname) : "";
                        var eventName = buttonName ? "Click_".concat(pageName, "_").concat(buttonName) : "Click_".concat(pageName, "_Button");
                        var event = _this.createEvent("click", eventName, pageName, buttonName, properties);
                        _this.addToQueue(event);
                    }
                };
            }
        },
        {
            key: "Element",
            value: function Element(elementName) {
                var _this = this;
                return {
                    name: function(name) {
                        return {
                            expose: function(properties) {
                                var pageName = typeof window !== "undefined" ? _this.cleanPageName(window.location.pathname) : "";
                                var eventName = "Expose_".concat(pageName, "_").concat(name);
                                var event = _this.createEvent("expose", eventName, pageName, name, properties);
                                _this.addToQueue(event);
                            },
                            disappear: function(exposeTime, properties, originalPage) {
                                var pageName = originalPage ? _this.cleanPageName(originalPage) : typeof window !== "undefined" ? _this.cleanPageName(window.location.pathname) : "";
                                var eventName = "Disappear_".concat(pageName, "_").concat(name);
                                var event = _this.createEvent("disappear", eventName, pageName, name, properties);
                                event.exposeTime = exposeTime;
                                _this.addToQueue(event);
                            }
                        };
                    },
                    expose: function(properties) {
                        var pageName = typeof window !== "undefined" ? _this.cleanPageName(window.location.pathname) : "";
                        var eventName = elementName ? "Expose_".concat(pageName, "_").concat(elementName) : "Expose_".concat(pageName, "_Element");
                        var event = _this.createEvent("expose", eventName, pageName, elementName, properties);
                        _this.addToQueue(event);
                    },
                    disappear: function(exposeTime, properties, originalPage) {
                        var pageName = originalPage ? _this.cleanPageName(originalPage) : typeof window !== "undefined" ? _this.cleanPageName(window.location.pathname) : "";
                        var eventName = elementName ? "Disappear_".concat(pageName, "_").concat(elementName) : "Disappear_".concat(pageName, "_Element");
                        var event = _this.createEvent("disappear", eventName, pageName, elementName, properties);
                        event.exposeTime = exposeTime;
                        _this.addToQueue(event);
                    }
                };
            }
        },
        {
            // 直接發送事件（不使用鏈式 API）
            key: "track",
            value: function track(eventType, eventName, properties) {
                var pageName = typeof window !== "undefined" ? this.cleanPageName(window.location.pathname) : "";
                var event = this.createEvent(eventType, eventName, pageName, void 0, properties);
                this.addToQueue(event);
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (!_Tracker.instance) {
                    _Tracker.instance = new _Tracker();
                }
                return _Tracker.instance;
            }
        }
    ]);
    return _Tracker;
}();
var trackerInstance = null;
var getTracker = function() {
    if (typeof window === "undefined") return null;
    if (!trackerInstance) {
        trackerInstance = Tracker.getInstance();
    }
    return trackerInstance;
};
var configure = function(config) {
    var _getTracker;
    (_getTracker = getTracker()) === null || _getTracker === void 0 ? void 0 : _getTracker.configure(config);
};
var Page = function(pageName) {
    var tracker = getTracker();
    return (tracker === null || tracker === void 0 ? void 0 : tracker.Page(pageName)) || {
        view: function() {},
        name: function() {
            return {
                view: function() {}
            };
        }
    };
};
var Button = function(buttonName) {
    var tracker = getTracker();
    return (tracker === null || tracker === void 0 ? void 0 : tracker.Button(buttonName)) || {
        click: function() {},
        name: function() {
            return {
                click: function() {}
            };
        }
    };
};
var Element = function(elementName) {
    var tracker = getTracker();
    return (tracker === null || tracker === void 0 ? void 0 : tracker.Element(elementName)) || {
        expose: function() {},
        disappear: function() {},
        name: function() {
            return {
                expose: function() {},
                disappear: function() {}
            };
        }
    };
};
var flush = function() {
    var _getTracker;
    (_getTracker = getTracker()) === null || _getTracker === void 0 ? void 0 : _getTracker.flush();
};
// autoTrack.ts
function isClickableElement(element) {
    var _element_getAttribute;
    var tagName = element.tagName.toLowerCase();
    if (tagName === "button" || tagName === "a") return true;
    if (tagName === "input") {
        var _element_getAttribute1;
        var type = (_element_getAttribute1 = element.getAttribute("type")) === null || _element_getAttribute1 === void 0 ? void 0 : _element_getAttribute1.toLowerCase();
        return type === "submit" || type === "button" || type === "reset";
    }
    var role = (_element_getAttribute = element.getAttribute("role")) === null || _element_getAttribute === void 0 ? void 0 : _element_getAttribute.toLowerCase();
    if (role === "button" || role === "link" || role === "menuitem" || role === "tab") return true;
    return false;
}
function parseTrackEvents(eventsStr, element) {
    if (eventsStr) {
        var events = eventsStr.split(",").map(function(e) {
            return e.trim().toLowerCase();
        });
        return events.filter(function(e) {
            return e === "click" || e === "expose";
        });
    }
    if (element && isClickableElement(element)) {
        return [
            "click"
        ];
    }
    return [
        "expose"
    ];
}
function parseTrackProps(propsStr) {
    if (!propsStr) return void 0;
    try {
        return JSON.parse(propsStr);
    } catch (error) {
        console.error("[Analytics] Invalid JSON in data-track-props:", propsStr, error);
        return void 0;
    }
}
function initAutoClickTracking() {
    if (typeof document === "undefined") return;
    console.log("[Analytics] Auto-click tracking initialized");
    document.addEventListener("click", function(e) {
        var target = e.target;
        var tracked = target.closest("[data-track-click]");
        if (tracked) {
            var name = tracked.getAttribute("data-track-click");
            var propsStr = tracked.getAttribute("data-track-props");
            if (name) {
                var properties;
                if (propsStr) {
                    try {
                        properties = JSON.parse(propsStr);
                    } catch (error) {
                        console.error("[Analytics] Invalid JSON in data-track-props:", propsStr, error);
                    }
                }
                Button().name(name).click(properties);
                console.log("[Analytics] Auto-tracked click:", name, properties);
            }
        }
    }, true);
}
function initAutoExposeTracking() {
    if (typeof window === "undefined") return;
    if (!("IntersectionObserver" in window)) {
        console.warn("[Analytics] IntersectionObserver not supported, auto-expose tracking disabled");
        return;
    }
    console.log("[Analytics] Auto-expose tracking initialized");
    var exposeTimes = /* @__PURE__ */ new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var target = entry.target;
            var name = target.getAttribute("data-track-expose");
            if (!name) return;
            var propsStr = target.getAttribute("data-track-props");
            var properties;
            if (propsStr) {
                try {
                    properties = JSON.parse(propsStr);
                } catch (error) {
                    console.error("[Analytics] Invalid JSON in data-track-props:", propsStr, error);
                }
            }
            if (entry.isIntersecting && !exposeTimes.has(target)) {
                exposeTimes.set(target, {
                    startTime: Date.now(),
                    page: window.location.pathname
                });
                Element().name(name).expose(properties);
                console.log("[Analytics] Auto-tracked expose:", name, properties);
            } else if (!entry.isIntersecting && exposeTimes.has(target)) {
                var _exposeTimes_get = exposeTimes.get(target), startTime = _exposeTimes_get.startTime, page = _exposeTimes_get.page;
                var exposeTime = Math.floor((Date.now() - startTime) / 1e3);
                exposeTimes.delete(target);
                Element().name(name).disappear(exposeTime, properties, page);
                console.log("[Analytics] Auto-tracked disappear:", name, "duration:", exposeTime, "s");
            }
        });
    }, {
        threshold: 0.1
    });
    var trackElements = function() {
        document.querySelectorAll("[data-track-expose]").forEach(function(el) {
            observer.observe(el);
        });
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", trackElements);
    } else {
        trackElements();
    }
    var mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    var element = node;
                    requestAnimationFrame(function() {
                        requestAnimationFrame(function() {
                            if (element.hasAttribute("data-track-expose")) {
                                observer.observe(element);
                            }
                            element.querySelectorAll("[data-track-expose]").forEach(function(el) {
                                observer.observe(el);
                            });
                        });
                    });
                }
            });
        });
    });
    mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
}
function initAutoDialogTracking() {
    if (typeof window === "undefined") return;
    console.log("[Analytics] Auto-dialog tracking initialized");
    var dialogTimes = /* @__PURE__ */ new Map();
    var checkVisibility = function(target) {
        return target.offsetParent !== null && // Not display:none
        window.getComputedStyle(target).visibility !== "hidden" && window.getComputedStyle(target).opacity !== "0";
    };
    var handleVisibilityChange = function(target) {
        var name = target.getAttribute("data-track-dialog");
        if (!name) return;
        var isVisible = checkVisibility(target);
        var wasVisible = dialogTimes.has(target);
        if (isVisible && !wasVisible) {
            dialogTimes.set(target, {
                startTime: Date.now(),
                page: window.location.pathname
            });
            Element().name(name).expose();
            console.log("[Analytics] Dialog opened: ".concat(name));
        } else if (!isVisible && wasVisible) {
            var _dialogTimes_get = dialogTimes.get(target), startTime = _dialogTimes_get.startTime, page = _dialogTimes_get.page;
            var exposeTime = Math.floor((Date.now() - startTime) / 1e3);
            dialogTimes.delete(target);
            Element().name(name).disappear(exposeTime, void 0, page);
            console.log("[Analytics] Dialog closed: ".concat(name, ", duration: ").concat(exposeTime, "s"));
        }
    };
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === "attributes") {
                var target = mutation.target;
                if (target.hasAttribute("data-track-dialog")) {
                    handleVisibilityChange(target);
                }
            }
        });
    });
    var observeDialogs = function() {
        document.querySelectorAll("[data-track-dialog]").forEach(function(el) {
            observer.observe(el, {
                attributes: true,
                attributeFilter: [
                    "style",
                    "class",
                    "hidden",
                    "open"
                ]
            });
        });
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", observeDialogs);
    } else {
        observeDialogs();
    }
    var bodyObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    var element = node;
                    if (element.hasAttribute("data-track-dialog")) {
                        observer.observe(element, {
                            attributes: true,
                            attributeFilter: [
                                "style",
                                "class",
                                "hidden",
                                "open"
                            ]
                        });
                    }
                    element.querySelectorAll("[data-track-dialog]").forEach(function(el) {
                        observer.observe(el, {
                            attributes: true,
                            attributeFilter: [
                                "style",
                                "class",
                                "hidden",
                                "open"
                            ]
                        });
                    });
                }
            });
        });
    });
    bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
}
function initUnifiedTracking() {
    if (typeof window === "undefined") return;
    if (typeof document === "undefined") return;
    console.log("[Analytics] Unified tracking initialized");
    var exposeTimes = /* @__PURE__ */ new Map();
    var intersectionObserver = "IntersectionObserver" in window ? new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var target = entry.target;
            var name = target.getAttribute("data-track");
            if (!name) return;
            var events = parseTrackEvents(target.getAttribute("data-track-events"), target);
            if (!events.includes("expose")) return;
            var properties = parseTrackProps(target.getAttribute("data-track-props"));
            if (entry.isIntersecting && !exposeTimes.has(target)) {
                exposeTimes.set(target, {
                    startTime: Date.now(),
                    page: window.location.pathname
                });
                Element().name(name).expose(properties);
                console.log("[Analytics] Unified expose:", name, properties);
            } else if (!entry.isIntersecting && exposeTimes.has(target)) {
                var _exposeTimes_get = exposeTimes.get(target), startTime = _exposeTimes_get.startTime, page = _exposeTimes_get.page;
                var exposeTime = Math.floor((Date.now() - startTime) / 1e3);
                exposeTimes.delete(target);
                Element().name(name).disappear(exposeTime, properties, page);
                console.log("[Analytics] Unified disappear:", name, "duration:", exposeTime, "s");
            }
        });
    }, {
        threshold: 0.1
    }) : null;
    if (!intersectionObserver) {
        console.warn("[Analytics] IntersectionObserver not supported, expose tracking disabled");
    }
    document.addEventListener("click", function(e) {
        var target = e.target;
        var tracked = target.closest("[data-track]");
        if (tracked) {
            var name = tracked.getAttribute("data-track");
            if (!name) return;
            var events = parseTrackEvents(tracked.getAttribute("data-track-events"), tracked);
            if (!events.includes("click")) return;
            var properties = parseTrackProps(tracked.getAttribute("data-track-props"));
            Button().name(name).click(properties);
            console.log("[Analytics] Unified click:", name, properties);
        }
    }, true);
    var setupElement = function(element) {
        var name = element.getAttribute("data-track");
        if (!name) return;
        var events = parseTrackEvents(element.getAttribute("data-track-events"), element);
        if (events.includes("expose") && intersectionObserver) {
            intersectionObserver.observe(element);
        }
    };
    var trackElements = function() {
        document.querySelectorAll("[data-track]").forEach(function(el) {
            setupElement(el);
        });
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", trackElements);
    } else {
        trackElements();
    }
    var mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    var element = node;
                    requestAnimationFrame(function() {
                        requestAnimationFrame(function() {
                            if (element.hasAttribute("data-track")) {
                                setupElement(element);
                            }
                            element.querySelectorAll("[data-track]").forEach(function(el) {
                                setupElement(el);
                            });
                        });
                    });
                }
            });
        });
    });
    mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
}
function initAutoTracking() {
    initUnifiedTracking();
    initAutoClickTracking();
    initAutoExposeTracking();
    initAutoDialogTracking();
    console.log("[Analytics] All auto-tracking features initialized");
}
// providerLegacy.tsx
var AnalyticsProvider = /*#__PURE__*/ function(_import_react_Component) {
    _inherits(AnalyticsProvider, _import_react_Component);
    function AnalyticsProvider(props) {
        _class_call_check(this, AnalyticsProvider);
        var _this;
        _this = _call_super(this, AnalyticsProvider, [
            props
        ]);
        _this.autoTrackInitialized = false;
        _this.handleRouteChange = function() {
            Page().view();
        };
        return _this;
    }
    _create_class(AnalyticsProvider, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this_props = this.props, apiEndpoint = _this_props.apiEndpoint, trackingApiUrl = _this_props.trackingApiUrl, production = _this_props.production, platform = _this_props.platform, employeeId = _this_props.employeeId, companyId = _this_props.companyId, companyName = _this_props.companyName, userName = _this_props.userName, autoTrack = _this_props.autoTrack;
                console.log("[Analytics] Configured with production:", production, "platform:", platform);
                configure({
                    apiEndpoint: apiEndpoint,
                    trackingApiUrl: trackingApiUrl,
                    production: production,
                    platform: platform,
                    employeeId: employeeId,
                    companyId: companyId,
                    companyName: companyName,
                    userName: userName
                });
                if (autoTrack && !this.autoTrackInitialized) {
                    initAutoTracking();
                    this.autoTrackInitialized = true;
                }
                Page().view();
                if (typeof window !== "undefined") {
                    window.addEventListener("pushstate", this.handleRouteChange);
                    window.addEventListener("popstate", this.handleRouteChange);
                    window.addEventListener("replacestate", this.handleRouteChange);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (typeof window !== "undefined") {
                    window.removeEventListener("pushstate", this.handleRouteChange);
                    window.removeEventListener("popstate", this.handleRouteChange);
                    window.removeEventListener("replacestate", this.handleRouteChange);
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.apiEndpoint !== this.props.apiEndpoint || prevProps.trackingApiUrl !== this.props.trackingApiUrl || prevProps.production !== this.props.production || prevProps.platform !== this.props.platform || prevProps.employeeId !== this.props.employeeId || prevProps.companyId !== this.props.companyId || prevProps.companyName !== this.props.companyName || prevProps.userName !== this.props.userName) {
                    var _this_props = this.props, apiEndpoint = _this_props.apiEndpoint, trackingApiUrl = _this_props.trackingApiUrl, production = _this_props.production, platform = _this_props.platform, employeeId = _this_props.employeeId, companyId = _this_props.companyId, companyName = _this_props.companyName, userName = _this_props.userName;
                    configure({
                        apiEndpoint: apiEndpoint,
                        trackingApiUrl: trackingApiUrl,
                        production: production,
                        platform: platform,
                        employeeId: employeeId,
                        companyId: companyId,
                        companyName: companyName,
                        userName: userName
                    });
                    console.log("[Analytics] Configuration updated");
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return AnalyticsProvider;
}(import_react.Component);
// hocLegacy.tsx
var React = __toESM(require("react"));
var import_react2 = require("react");
function withTrackingLegacy(WrappedComponent, options) {
    var _a;
    var type = options.type, name = options.name, properties = options.properties;
    return _a = /*#__PURE__*/ function(_import_react2_Component) {
        _inherits(_a, _import_react2_Component);
        function _a() {
            _class_call_check(this, _a);
            var _this;
            _this = _call_super(this, _a, arguments);
            _this.observer = null;
            _this.elementRef = null;
            _this.exposeStartTime = 0;
            _this.exposePage = "";
            _this.handleClick = function(e) {
                if (type === "click" || type === "interactive") {
                    Button().name(name).click(properties);
                }
                var originalOnClick = _this.props.onClick;
                if (originalOnClick) {
                    originalOnClick(e);
                }
            };
            _this.setRef = function(el) {
                _this.elementRef = el;
                if (el && (type === "expose" || type === "interactive")) {
                    _this.setupExposureTracking();
                }
                var ref = _this.props.ref;
                if (ref) {
                    if (typeof ref === "function") {
                        ref(el);
                    } else if (ref && (typeof ref === "undefined" ? "undefined" : _type_of(ref)) === "object") {
                        ref.current = el;
                    }
                }
            };
            return _this;
        }
        _create_class(_a, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (type === "expose" || type === "interactive") {
                        this.setupExposureTracking();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.observer) {
                        this.observer.disconnect();
                    }
                    if (this.exposeStartTime > 0) {
                        var exposeTime = Math.floor((Date.now() - this.exposeStartTime) / 1e3);
                        Element().name(name).disappear(exposeTime, properties, this.exposePage);
                    }
                }
            },
            {
                key: "setupExposureTracking",
                value: function setupExposureTracking() {
                    var _this = this;
                    if (typeof window === "undefined" || !this.elementRef) return;
                    if (!("IntersectionObserver" in window)) {
                        console.warn("[Analytics] IntersectionObserver not supported, exposure tracking disabled");
                        return;
                    }
                    this.observer = new IntersectionObserver(function(entries) {
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting && _this.exposeStartTime === 0) {
                                _this.exposeStartTime = Date.now();
                                _this.exposePage = typeof window !== "undefined" ? window.location.pathname : "";
                                Element().name(name).expose(properties);
                            } else if (!entry.isIntersecting && _this.exposeStartTime > 0) {
                                var exposeTime = Math.floor((Date.now() - _this.exposeStartTime) / 1e3);
                                Element().name(name).disappear(exposeTime, properties, _this.exposePage);
                                _this.exposeStartTime = 0;
                                _this.exposePage = "";
                            }
                        });
                    }, {
                        threshold: 0.5
                    });
                    this.observer.observe(this.elementRef);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this;
                    var enhancedProps = _object_spread({}, this.props);
                    if (type === "expose" || type === "interactive") {
                        enhancedProps.ref = this.setRef;
                    }
                    if (type === "click" || type === "interactive") {
                        var originalOnClick = enhancedProps.onClick;
                        enhancedProps.onClick = function(e) {
                            _this.handleClick(e);
                            if (originalOnClick) {
                                originalOnClick(e);
                            }
                        };
                    }
                    return React.createElement(WrappedComponent, enhancedProps);
                }
            }
        ]);
        return _a;
    }(import_react2.Component), _a.displayName = "withTracking(".concat(WrappedComponent.displayName || WrappedComponent.name || "Component", ")"), _a;
}
// DialogTracker.ts
var DialogTracker = /*#__PURE__*/ function() {
    function DialogTracker(name) {
        _class_call_check(this, DialogTracker);
        this.startTime = 0;
        this.startPage = "";
        this.isTracking = false;
        this.name = name;
    }
    _create_class(DialogTracker, [
        {
            /**
   * Manual: call when dialog opens
   * Sends Expose event and starts timing
   */ key: "open",
            value: function open() {
                if (!this.isTracking) {
                    this.startTime = Date.now();
                    this.startPage = typeof window !== "undefined" ? window.location.pathname : "";
                    this.isTracking = true;
                    Element().name(this.name).expose();
                    console.log("[Analytics] Dialog exposed: ".concat(this.name));
                }
            }
        },
        {
            /**
   * Manual: call when dialog closes
   * Sends Disappear event with duration
   */ key: "close",
            value: function close() {
                if (this.isTracking) {
                    var exposeTime = Math.floor((Date.now() - this.startTime) / 1e3);
                    Element().name(this.name).disappear(exposeTime, void 0, this.startPage);
                    console.log("[Analytics] Dialog disappeared: ".concat(this.name, ", duration: ").concat(exposeTime, "s"));
                    this.isTracking = false;
                    this.startTime = 0;
                    this.startPage = "";
                }
            }
        },
        {
            /**
   * Auto-sync: call in componentDidUpdate with isOpen state
   * Automatically detects state changes and tracks accordingly
   */ key: "sync",
            value: function sync(isOpen) {
                if (isOpen && !this.isTracking) {
                    this.open();
                } else if (!isOpen && this.isTracking) {
                    this.close();
                }
            }
        },
        {
            /**
   * Call in componentWillUnmount to ensure proper cleanup
   * Sends Disappear event if dialog is still open
   */ key: "cleanup",
            value: function cleanup() {
                if (this.isTracking) {
                    var exposeTime = Math.floor((Date.now() - this.startTime) / 1e3);
                    Element().name(this.name).disappear(exposeTime, void 0, this.startPage);
                    console.log("[Analytics] Dialog disappeared on unmount: ".concat(this.name, ", duration: ").concat(exposeTime, "s"));
                    this.isTracking = false;
                    this.startTime = 0;
                    this.startPage = "";
                }
            }
        }
    ]);
    return DialogTracker;
}();
function createDialogTracker(name) {
    return new DialogTracker(name);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
    AnalyticsProvider: AnalyticsProvider,
    Button: Button,
    DialogTracker: DialogTracker,
    Element: Element,
    Page: Page,
    configure: configure,
    createDialogTracker: createDialogTracker,
    flush: flush,
    withTrackingLegacy: withTrackingLegacy
});
//# sourceMappingURL=legacy.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/react-analytics-tracker/dist/legacy.js
 ** module id = 907
 ** module chunks = 73
 **/